import { useCallback, useMemo } from 'react';
import debounce from 'react-utils/debounce';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
/**
 * Need to use transitional Select for loadOptions support, issue https://hubspot.slack.com/archives/C1WG3L3J6/p1738081133328599
 * @TODO: update to below import until it's exported from foundations-components
 * `import { Select } from 'foundations-components/transitional/components/Select/Select';`
 */
import Select from 'UIComponents/input/UISelect';
import { SEARCH_ELIGIBLE_USERS_QUERY, useSearchEligibleUsers } from 'setup-guide-api/dataFetchingClient/queries/assignedTasks';
import { useAuth } from '../../hooks/auth';
import { jsx as _jsx } from "react/jsx-runtime";
const getSelectOptions = (users, currentUserId) => {
  return users.map(({
    userId,
    firstName,
    lastName,
    eligible
  }) => ({
    value: userId,
    text: formatName({
      firstName,
      lastName
    }) || I18n.text('setup-guide-components.assignTaskModal.newUser'),
    disabled: !eligible || userId === currentUserId
  }));
};
const AssignTaskUserSelect = ({
  selectedTeamMemberId,
  onTeamMemberSelect,
  taskId
}) => {
  const {
    user_id: currentUserId
  } = useAuth().user;
  const [searchEligibleUsers, {
    client
  }] = useSearchEligibleUsers({
    taskId,
    searchQuery: ''
  });
  const searchUserOptions = useMemo(() => debounce((input, callback) => {
    var _queryResult$searchEl;
    const queryResult = client.readQuery({
      query: SEARCH_ELIGIBLE_USERS_QUERY,
      variables: {
        taskId,
        searchQuery: input
      }
    });
    const cachedUsers = queryResult === null || queryResult === void 0 || (_queryResult$searchEl = queryResult.searchEligibleUsers) === null || _queryResult$searchEl === void 0 ? void 0 : _queryResult$searchEl.results;
    if (cachedUsers) {
      const options = getSelectOptions(cachedUsers, currentUserId);
      callback(null, {
        options
      });
      return;
    }
    searchEligibleUsers({
      variables: {
        taskId,
        searchQuery: input
      },
      onCompleted(data) {
        var _data$searchEligibleU;
        const users = (data === null || data === void 0 || (_data$searchEligibleU = data.searchEligibleUsers) === null || _data$searchEligibleU === void 0 ? void 0 : _data$searchEligibleU.results) || [];
        const options = getSelectOptions(users, currentUserId);
        callback(null, {
          options
        });
      },
      onError(error) {
        callback(error);
      }
    });
  }, 300), [client, currentUserId, searchEligibleUsers, taskId]);
  const loadOptions = useCallback((input, callback) => {
    if (!input) {
      return callback(null);
    }
    return searchUserOptions(input, callback);
  }, [searchUserOptions]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.assignTaskModal.dropdownLabel"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "assign-task-dropdown",
      filterOptions: false,
      loadOptions: loadOptions,
      onChange: ({
        target: {
          value
        }
      }) => {
        onTeamMemberSelect(Number(value));
      },
      searchable: true,
      value: selectedTeamMemberId
    })
  });
};
export default AssignTaskUserSelect;